import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './StructureFilter.scss';

export default function StructureFilterSelectedOptionTitles(props) {
  const { selectedOptionTitles, optionsButtonOnClick } = props;

  if (!selectedOptionTitles) {
    return null;
  }

  const countTitles = selectedOptionTitles.length;
  const resultTitles = countTitles > 3 ? [selectedOptionTitles[0], '...', selectedOptionTitles[countTitles - 1]] : selectedOptionTitles;

  return (
    <Button
      onClick={optionsButtonOnClick}
      buttonConfig={{ type: 'link', size: 'sm', className: 'structure-filter-options-button', e2eName: 'edit-options' }}
      iconConfig={{ name: 'pencil', size: 'sm' }}
      title="Click to change options">
      {resultTitles.map((title) => (
        <span key={title} className="structure-filter-options-button-item rx-border-none">
          {title}
        </span>
      ))}
    </Button>
  );
}

StructureFilterSelectedOptionTitles.propTypes = {
  selectedOptionTitles: PropTypes.array,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
